import { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { Button } from '@iwoca/orion';
import styles from './OnfidoVerificationModal.module.css';
import messages from './OnfidoVerificationModal.messages';
import PeopleToVerify from './peopleToVerify/PeopleToVerify';
import { RootState } from '@iwProvider/configureStore';

const mapStateToProps = (state: RootState) => state.onfidoVerificationModal;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

class OnfidoVerificationModal extends Component<
    { onClose: () => void } & PropsFromRedux
> {
    render() {
        const hasMultiplePeopleToVerify = this.props.peopleToVerify.length > 1;

        return (
            <div className={styles.OnfidoVerificationModal}>
                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>
                <div className={styles.subTitle}>
                    {!hasMultiplePeopleToVerify ? (
                        <FormattedMessage {...messages.subTitle} />
                    ) : (
                        <FormattedMessage {...messages.subTitleMultiple} />
                    )}
                </div>
                <div className={styles.requirementsSubTitle}>
                    {!hasMultiplePeopleToVerify ? (
                        <FormattedMessage {...messages.requirementsSubTitle} />
                    ) : (
                        <FormattedMessage
                            {...messages.requirementsSubTitleMultiple}
                        />
                    )}
                </div>

                <PeopleToVerify />

                <div
                    className={styles.infoMessage}
                    data-testid="onfido-status-info"
                >
                    {this.renderInfoMessage()}
                </div>

                <div>
                    <Button
                        className={styles.proceedButton}
                        onClick={this.props.onClose}
                    >
                        <FormattedMessage
                            tagName="strong"
                            {...messages.continueText}
                        />
                    </Button>
                </div>
            </div>
        );
    }

    renderInfoMessage() {
        const { peopleToVerify, reachedMaxOnfidoAttempts } = this.props;

        const hasMultiplePeopleToVerify = peopleToVerify.length > 1;

        let message;

        _.map(peopleToVerify, (person) => {
            const hasSMSFailed = person.status === 'SMS failed';

            if (hasSMSFailed) {
                return (message = <FormattedMessage {...messages.smsFailed} />);
            }

            if (reachedMaxOnfidoAttempts) {
                return (message = (
                    <FormattedMessage
                        {...messages.reachedMaxOnfidoChecks}
                        values={{
                            phoneNumber: (
                                <FormattedMessage
                                    tagName="strong"
                                    {...messages.phoneNumber}
                                />
                            )
                        }}
                    />
                ));
            }

            if (
                person.onfidoStatus === 'Something went wrong' &&
                !hasSMSFailed
            ) {
                message = (
                    <FormattedMessage {...messages.somethingWentWrongInfo} />
                );
            }

            if (
                person.onfidoStatus === 'Not started yet' &&
                !hasMultiplePeopleToVerify
            ) {
                message = (
                    <FormattedMessage
                        {...messages.makeSureAllTextsSentInfo}
                        values={{
                            phoneNumber: (
                                <span>
                                    <FormattedMessage
                                        tagName="strong"
                                        {...messages.phoneNumber}
                                        values={{
                                            phoneNumber: (
                                                <FormattedMessage
                                                    tagName="strong"
                                                    {...messages.phoneNumber}
                                                />
                                            )
                                        }}
                                    />
                                </span>
                            )
                        }}
                    />
                );
            }

            if (
                person.onfidoStatus === 'Not started yet' &&
                hasMultiplePeopleToVerify
            ) {
                message = (
                    <FormattedMessage
                        {...messages.makeSureAllTextsSentInfoMultiple}
                        values={{
                            phoneNumber: (
                                <FormattedMessage
                                    tagName="strong"
                                    {...messages.phoneNumber}
                                />
                            )
                        }}
                    />
                );
            }

            if (_.includes(person.onfidoStatus, 'Verifying')) {
                message = (
                    <FormattedMessage
                        {...messages.makeSureAllTextsSentInfoMultiple}
                        values={{
                            phoneNumber: (
                                <FormattedMessage
                                    tagName="strong"
                                    {...messages.phoneNumber}
                                />
                            )
                        }}
                    />
                );
            }
        });
        return message;
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(OnfidoVerificationModal);
